import React from 'react';
import {ErrorDetails, ErrorCard} from './Error';
import ErrorIcon from './ErrorIcon';
import ErrorHorizontal from './ErrorHorizontal';

const ErrorMicro = ({isAccessDenied}) => (
  <ErrorIcon isAccessDenied={isAccessDenied} size={ErrorIcon.SIZES.MICRO} />
);

export const card = ErrorCard;
export const details = ErrorDetails;
export const micro = ErrorMicro;
export const icon = ErrorMicro;
export const horizontal = ErrorHorizontal;
export const preview = ErrorCard;
